module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-latin32.92425c6.woff2";